import React, { useContext } from "react";
import { Link } from "react-router-dom";
import UserContext from "../context/UserContext.js";
import MapComponent from "../map/MapComponent.js";
import "./Home.css";

const Home = () => {
  const { currentUser } = useContext(UserContext);

  const loggedInHomepage = () => (
    <>
      <div className="home-welcome-bar">
        <h2 className="home-welcome-title">Welcome back, {currentUser.username}</h2>
        <Link to="/spaces" className="btn-primary-custom">Explore Spaces</Link>
      </div>
      <div className="home-map-section">
        <p className="home-map-label">All Designed Spaces</p>
        <MapComponent />
      </div>
    </>
  );

  const anonHomepage = () => (
    <>
      <div className="home-hero">
        <div className="home-hero-content">
          <p className="home-hero-label">Interior Design</p>
          <h1 className="home-hero-title">Every Space Bells+Whistles Has Ever Designed</h1>
          <p className="home-hero-sub">
            Explore our full portfolio of designed spaces across cities and neighborhoods.
          </p>
          <div className="home-hero-actions">
            <Link to="/signup" className="btn-primary-custom">Get Started</Link>
            <Link to="/login" className="btn-outline-custom">Sign In</Link>
          </div>
        </div>
      </div>

      <div className="home-how-it-works">
        <p className="home-hero-label">How it works</p>
        <div className="home-steps">
          <div className="home-step">
            <div className="home-step-number">1</div>
            <h3 className="home-step-title">Create an account</h3>
            <p className="home-step-desc">
              Sign up for free to unlock the full portfolio. Your account keeps track of your favorites and visited spaces.
            </p>
          </div>
          <div className="home-step">
            <div className="home-step-number">2</div>
            <h3 className="home-step-title">Browse &amp; filter spaces</h3>
            <p className="home-step-desc">
              Search by name, filter by category, city, or neighborhood, and sort by rating to find spaces you'll love.
            </p>
          </div>
          <div className="home-step">
            <div className="home-step-number">3</div>
            <h3 className="home-step-title">Explore the map</h3>
            <p className="home-step-desc">
              See every designed space pinned on an interactive world map. Click any pin to learn more and navigate to that space.
            </p>
          </div>
          <div className="home-step">
            <div className="home-step-number">4</div>
            <h3 className="home-step-title">Like &amp; save your favorites</h3>
            <p className="home-step-desc">
              Heart the spaces you love and mark ones you want to visit. Find them all saved on your profile anytime.
            </p>
          </div>
        </div>
        <div className="home-how-cta">
          <Link to="/signup" className="btn-primary-custom">Create a free account</Link>
        </div>
      </div>
    </>
  );

  return (
    <>
      {currentUser ? loggedInHomepage() : anonHomepage()}
    </>
  );
};

export default Home;
